var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import Header from './component/AddHeader.vue';
import ELogisticsType from '../../enum/ELogisticsType';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import { Watch } from 'vue-property-decorator';
import RootType from '../../store/mutation-types';
import { numAdd, numSub, numMulti, numDiv } from '../../helper/calucate';
import QuotedPrice from '../../api/QuotedPrice';
import DeliverService from '../../api/DeliverService';
import GoodsStockService from '../../api/GoodsStockService';
import BasicArcheivesService from '../../api/BasicArcheivesService';
import GLOBAL_VUE from '../../globalVue';
import _ from 'lodash';
import { BigNumber } from "bignumber.js";
import { Loading } from 'element-ui';
import { auth } from '../../helper/authDecorator';
import { UrlHelper } from '../../helper/UrlWrapper';
import { nameDict } from '../../constant/authCode';
import { mapGetters } from 'vuex';
import EOrderFromSystem from '../../enum/EOrderFromSystem';
import { EPurOrderErrorCode } from "../../enum/EPurchaseOrderCode";
import CommonService from '../../api/CommonService';
import SystemSettingsService from '../../api/SystemSettingsService';
import DistriDialog from './component/DistributionDialog.vue';
import SeeBindLicenses from '../good/SeeBindLicenses';
import ArticleList from "../../components/alert/ArticleList.vue";
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import Client from '../client/List.vue';
import Purchase from '../purchase/List.vue';
import TableFieldConfig from '@/components/common/TableFieldConfig.vue';
import GoodTable from './component/DeliverAddGoodTable.vue';
import SelectStockBatch from './component/SelectStockBatch.vue';
import MulOrderDetailOamount from './component/MulOrderDetailOamount.vue';
import OCRUpload from './component/OCRUpload.vue';
export var EOrderType;
(function (EOrderType) {
    EOrderType[EOrderType["ORDER"] = 0] = "ORDER";
    EOrderType[EOrderType["NO_ORDER"] = 1] = "NO_ORDER";
    EOrderType[EOrderType["RETAIL"] = 2] = "RETAIL";
})(EOrderType || (EOrderType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eOrderFromSystem = EOrderFromSystem;
        _this.eLogisticsType = ELogisticsType;
        _this.orderHasMerge = false;
        _this.editOutDepot = true;
        _this.uploadShow = false;
        _this.ocrImportGoodList = [];
        _this.loadingOutDepotOptions = false;
        _this.formData = {
            from_system: '',
            order_type: '',
            business_id: '',
            supplier_to_business_id: '',
            shop_id: undefined,
            organ_id: '',
            out_depot_id: '',
            depot_id: '',
            depot_name: '',
            expect_arrivedate: '',
            reciever_phone: '',
            deliverer_id: '',
            deliverer_phone: '',
            delivery_plate_number: '',
            delivery_time: '',
            order_icomment: '',
            delivery_order_code: '',
            order_type_name: '',
            purchase_order_order: [],
            organ_name: '',
            shop_name: '',
            out_depot_name: '',
            sorting_order: [],
            customer: '',
            poo_last_ctime: '',
            is_modify_oamount: 1,
            is_modify_uprice: 1,
            is_show_uprice: 1,
            is_stock_up: '',
            can_gift_goods: 1,
            reciever_address: '',
            logistics_number: ''
        };
        _this.otherData = {
            outStoreList: [],
        };
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            }
        };
        _this.EOrderType = EOrderType;
        _this.from_system = 3;
        _this.orderid = '';
        _this.EHanldeStatus = EHanldeStatus;
        _this.goods_ids = [];
        _this.order_id = 0;
        _this.is_open_goods_replace = 2;
        _this.is_open_purchase_price = false;
        _this.changeDepotmodalShow = false;
        _this.depotList = [];
        _this.changeDepotId = '';
        _this.shipData = '';
        _this.selectGood = [];
        _this.activeTab = 'goods';
        _this.shopList = [];
        _this.baseGoodList = [];
        _this.baseShopList = [];
        _this.goodList = [];
        _this.isReady = false;
        _this.orderQrcode = '';
        _this.expireTime = moment(moment(new Date()).add(1, 'days')).format('YYYY-MM-DD');
        _this.isOpenOCR = false;
        _this.mulShopList = [];
        _this.mulOrderDetailRowData = {};
        _this.goodsTableData = [];
        _this.shopIndex = 0;
        _this.dialogTableVisible = false;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = '';
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = '';
        _this.importSuccessBusinessNum = 0;
        _this.importSuccessShopNum = 0;
        _this.supplierUpperId = '';
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.watchOrderType = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        this.goodList = [];
    };
    default_1.prototype.watchshop_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        this.goodList = [];
    };
    default_1.prototype.watchorgan_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            return;
        }
        ;
        if (newValue) {
            this.goodList = [];
        }
        else {
            this.otherData.outStoreList = [];
            return;
        }
    };
    default_1.prototype.watchout_depot_id = function (newValue, oldValue) {
        if (this.handleStatus === EHanldeStatus.Edit)
            return;
        this.goodList = [];
    };
    default_1.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.service = QuotedPrice.getInstance();
        this.systemService = SystemSettingsService.getInstance();
        this.deliverService = DeliverService.getInstance();
        this.goodsStockService = GoodsStockService.getInstance();
        this.basicArcheivesService = BasicArcheivesService.getInstance();
        if (this.handleStatus === EHandleStatus.Edit) {
            this.getEditOrderInfo();
        }
        else {
            this.isReady = true;
        }
        this.getSupplierConfigdetail();
        this.getOrderQrcode();
        this.getIsOpenOCR();
    };
    default_1.prototype.getIsOpenOCR = function () {
        var _this = this;
        this.commonService.getIsOpenOCR()
            .then(function (res) {
            if (res.data.success) {
                _this.isOpenOCR = !!(Array.isArray(res.data.data) && res.data.data.includes(3));
            }
            console.log('res>>>', res);
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.getOrderQrcode = function () {
        var _this = this;
        var params = { order_id: this.order_id };
        this.deliverService.getDeliveryOrderQrcode(params)
            .then(function (res) {
            if (res.data.success) {
                _this.orderQrcode = res.data.data.url;
            }
            console.log('res>>>', res);
        });
    };
    default_1.prototype.selectStockBatch = function (row) {
        this.$refs.SelectStockBatch.show(row);
    };
    default_1.prototype.batchSubmit = function (row) {
        if (row.batch_list.length) {
            var order_detail_oamount_1 = 0;
            var productionDateList = row.batch_list.map(function (item) { return item.production_date; });
            productionDateList.sort(function (a, b) {
                return moment(a).isBefore(b) ? -1 : 1;
            });
            row.production_date = productionDateList[0];
            row.batch_list.map(function (item) {
                order_detail_oamount_1 = numAdd(order_detail_oamount_1, item.order_detail_oamount);
            });
            row.order_detail_oamount = order_detail_oamount_1.toFixedNoZero(4);
        }
        else {
            row.order_detail_oamount = row.old_order_detail_oamount || 0;
        }
        console.log('batchSubmit', row);
    };
    default_1.prototype.dealManyShopAmount = function (row, index, listData, shopIndex) {
        var _this = this;
        this.mul_goods_format_index = index;
        this.mulOrderDetailRowData = JSON.parse(JSON.stringify(row));
        this.mulShopList = JSON.parse(JSON.stringify(row.items));
        this.goodsTableData = listData;
        this.shopIndex = shopIndex || 0;
        console.log('handle dealManyShopAmount>>>', this.shopIndex, row, index, listData);
        this.$nextTick(function () {
            _this.$refs.mulShop.showRelease();
        });
    };
    default_1.prototype.orderDetailOamountSave = function (data) {
        if (!data.length) {
            return;
        }
        var amount = BigNumber(0);
        var gift_amount = 0;
        data.forEach(function (item) {
            amount = numAdd(amount, item.order_detail_oamount);
            gift_amount = numAdd(gift_amount, item.order_gift_oamount);
        });
        console.log('orderDetailOamountSave', amount, gift_amount, data);
        this.goodsTableData[this.mul_goods_format_index].items = data;
        this.goodsTableData[this.mul_goods_format_index].order_detail_oamount = amount;
        this.goodsTableData[this.mul_goods_format_index].order_gift_oamount = gift_amount;
        this.inputChange(this.goodsTableData[this.mul_goods_format_index], 'order_detail_oamount');
        if (this.activeTab === 'shop') {
            this.shopList[this.shopIndex].items = _.cloneDeep(this.goodsTableData);
            return;
        }
    };
    default_1.prototype.organChange = function (value) {
        if (this.handleStatus === EHanldeStatus.Edit) {
            this.resetOutDepotOptions();
        }
        ;
    };
    default_1.prototype.showKeyConfig = function () {
        this.$refs.tableFieldConfig && this.$refs.tableFieldConfig.showKeyConfig();
    };
    default_1.prototype.getSupplierConfigdetail = function () {
        var _this = this;
        this.systemService.getSupplierConfigdetail({}).then(function (res) {
            if (res.data && res.data.success) {
                var data = res.data.data || {};
                _this.is_open_goods_replace = data.is_open_goods_replace || 2;
                _this.is_open_purchase_price = (data.is_erp === 1 && data.upper_warehouse_order_rule === 1);
                _this.$store.commit(RootType.UPDATE_IS_ERP, data.is_erp);
            }
        });
    };
    default_1.prototype.changeDepotmodalConfirm = function () {
        var _this = this;
        if (!this.changeDepotId)
            return this.$message.warning('请选择出库仓库');
        this.selections.map(function (item) {
            var index = _this.goodList.indexOf(item);
            GLOBAL_VUE.$set(_this.goodList[index], 'outDepotOptions', _this.depotList);
            GLOBAL_VUE.$set(_this.goodList[index], 'out_depot_id', _this.changeDepotId);
        });
        this.changeDepotmodalHide();
    };
    default_1.prototype.changeDepot = function () {
        if (!this.formData.organ_id)
            return this.$message.warning('请选择出库机构');
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请先选择货品');
            return;
        }
        this.getDepotList();
        this.changeDepotmodalShow = true;
    };
    default_1.prototype.openOCR = function () {
        try {
            this.validateAddGood(this.formData);
        }
        catch (err) {
            this.$message.warning(err.message);
            return;
        }
        this.uploadShow = true;
        this.getDepotList();
    };
    default_1.prototype.cancelDio = function () {
        this.uploadShow = false;
    };
    default_1.prototype.splitNote = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品后再进行拆分');
            return;
        }
        this.$confirm("\u8BF7\u786E\u8BA4\u662F\u5426\u5C06\u9009\u4E2D\u8D27\u54C1\u751F\u6210\u65B0\u7684\u9001\u8D27\u5355\uFF1F", '提示', {
            customClass: 'confirm',
            confirmButtonText: '确定',
        }).then(function (res) {
            if (res) {
                var params = {
                    order_id: _this.order_id,
                    delivery_order_id: _this.order_id,
                    organ_id: _this.formData.organ_id,
                    out_depot_id: _this.formData.out_depot_id,
                    expect_arrivedate: _this.formData.expect_arrivedate ? moment(_this.formData.expect_arrivedate).format('YYYY-MM-DD') : _this.formData.expect_arrivedate,
                    reciever_phone: _this.formData.reciever_phone,
                    deliverer_id: _this.formData.deliverer_id,
                    deliverer_phone: _this.formData.deliverer_phone,
                    delivery_plate_number: _this.formData.delivery_plate_number,
                    delivery_time: _this.formData.delivery_time
                        ? moment(_this.formData.delivery_time).format('YYYY-MM-DD HH:mm:ss')
                        : '',
                    order_icomment: _this.formData.order_icomment,
                    data: JSON.stringify(_this.selections),
                };
                _this.deliverService.splitDeliveryOrder(params).then(function (res) {
                    if (res.data.code == 0) {
                        _this.$message.success('操作成功');
                        var timer_1 = setTimeout(function () {
                            clearTimeout(timer_1);
                            GLOBAL_VUE.$emit('closeTab', _this);
                            _this.opener.search();
                        }, 500);
                        return;
                    }
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.getDepotList = function (callBack) {
        var _this = this;
        var params = {
            is_init: 1,
            organ_id: this.formData.organ_id,
        };
        this.commonService.getDepotList(params).then(function (res) {
            var data = Array.isArray(res.data.data) ? res.data.data : [];
            _this.depotList = data;
            callBack && callBack();
        });
    };
    default_1.prototype.changeDepotmodalHide = function () {
        this.changeDepotmodalShow = false;
        this.changeDepotId = '';
    };
    default_1.prototype.calc_stock = function (row) {
        return "" + row.order_remaining_stock + row.inventory_unit;
    };
    default_1.prototype.calc_deliveryVolume = function (row) {
        return numMulti(numAdd(row.order_detail_oamount || 0, row.order_gift_oamount || 0), row.sales_unit_coefficient).toFixedNoZero(4);
    };
    default_1.prototype.calc_amountIncludingTaxscope = function (row, type) {
        return (row[type] = numMulti(row.order_detail_oamount, row.order_detail_uprice).toFixedNoZero(4));
    };
    default_1.prototype.calc_taxAmount = function (row, type) {
        if (row.order_detail_tax_rate === 0) {
            return (row[type] = 0);
        }
        if (this.handleStatus === EHandleStatus.Edit) {
            var shifuMoney = numSub((row.order_detail_goods_money || 0), (row.order_detail_reduction_money || 0));
            var shuieMoney = numMulti(numDiv(shifuMoney, numAdd(1, row.order_detail_tax_rate)), row.order_detail_tax_rate);
            return (row[type] = shuieMoney.toFixedNoZero(4));
        }
        else {
            var firArg = numMulti(row.order_detail_oamount, row.order_detail_uprice);
            var secArg = numAdd(1, row.order_detail_tax_rate);
            return (row[type] = numMulti(numDiv(firArg, secArg), row.order_detail_tax_rate).toFixedNoZero(4));
        }
    };
    default_1.prototype.calc_amountOfMoney = function (row, type) {
        return (row[type] = numSub(row.order_detail_goods_money, row.order_detail_reduction_money).toFixedNoZero(4));
    };
    default_1.prototype.calc_amountOfGoodsMoney = function (row, type) {
        if (this.handleStatus === EHandleStatus.Edit) {
            var shifuMoney = numSub(row.order_detail_goods_money, row.order_detail_reduction_money || 0);
            var shuieMoney = numMulti(numDiv(shifuMoney, numAdd(1, row.order_detail_tax_rate)), row.order_detail_tax_rate);
            return (row[type] = numSub(shifuMoney, shuieMoney).toFixedNoZero(4));
        }
        else {
            var amountIncludingTaxs = numMulti(row.order_detail_oamount, row.order_detail_uprice);
            if (row.order_detail_tax_rate === 0) {
                amountIncludingTaxs.toFixedNoZero(4);
            }
            var taxRateAmount = numDiv(amountIncludingTaxs, numAdd(1, row.order_detail_tax_rate));
            var taxAmount = numMulti(taxRateAmount, row.order_detail_tax_rate);
            return (row[type] = numSub(amountIncludingTaxs, taxAmount).toFixedNoZero(4));
        }
    };
    default_1.prototype.pageChange = function (pager) {
    };
    default_1.prototype.blur_priceAndamount = function (data, name) {
        if (data[name] == '') {
            data[name] = 0;
        }
        else {
            data[name] = Number(data[name]);
        }
    };
    default_1.prototype.inputChange = function (row, key) {
        if (row[key])
            row[key] = String(row[key]).replace(/^\-?(\d*)(\.)?(\d{1,4}).*$/, '$1$2$3');
        if ((key === 'order_detail_uprice' || key === 'order_detail_goods_money') && parseFloat(row.order_detail_oamount)) {
            if (key === 'order_detail_uprice') {
                row['order_detail_goods_money'] = new Number(_.multiply(row.order_detail_uprice, row.order_detail_oamount)).toFixedNoZero(2);
            }
            else {
                row['order_detail_uprice'] = Math.floor(row.order_detail_goods_money / row.order_detail_oamount * 10000) / 10000;
            }
        }
        if (key === 'order_detail_oamount' && (parseFloat(row.order_detail_uprice) || parseFloat(row.order_detail_goods_money))) {
            row.batch_list = [];
            if (parseFloat(row.order_detail_uprice)) {
                row['order_detail_goods_money'] = new Number(_.multiply(row.order_detail_oamount, row.order_detail_uprice)).toFixedNoZero(2);
            }
            else {
                row['order_detail_uprice'] = Math.floor(row.order_detail_goods_money / row.order_detail_oamount * 10000) / 10000;
            }
        }
        if (key === 'order_detail_goods_money')
            row[key] = new Number(row[key]).toFixedNoZero(2);
        this.calc_amountOfMoney(row, 'order_detail_money');
    };
    default_1.prototype.outDepotChange = function (row) {
        var _this = this;
        row.batch_list = [];
        if (this.openedCodeData && this.openedCodeData.isOpenERP) {
            var params = {
                depot_id: row.out_depot_id,
                goods_format_id: row.goods_format_id,
            };
            return this.goodsStockService
                .getDepotGoodsFormatStock(params)
                .then(function (res) {
                var data = res.data.data;
                row.order_remaining_stock = data.order_remaining_stock;
                row.production_date = data.production_date;
            })
                .catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
    };
    default_1.prototype.generateGoodsTableData = function (list) {
        if (list === void 0) { list = []; }
        var now = Date.now();
        return (list || []).map(function (item, index) {
            item.order_goods_replace && item.order_goods_replace.length !== 0 ? item.children = [item.order_goods_replace] : '';
            item.isIndex = true;
            item.parentIndex = index + 1;
            item.production_date = moment(item.production_date || now).format('YYYY-MM-DD');
            item.rowKey = _.uniqueId() + "__" + item.goods_format_id;
            item.hasChildren = item.children && item.children.length ? true : false;
            if (item.hasChildren) {
                item.order_goods_replace_map = item.order_goods_replace;
                item.children.forEach(function (child) {
                    child.isChild = true;
                    child.rowKey = _.uniqueId() + "__" + child.goods_format_id;
                });
            }
            return item;
        });
    };
    default_1.prototype.initEditOrderData = function (data) {
        var _this = this;
        this.editOutDepot = data.delivery_order_status == 0 ? true : false;
        console.log(222222222, this.editOutDepot, data);
        this.orderHasMerge =
            data.logistics_type == this.eLogisticsType.Straight ||
                data.logistics_type == 4 ||
                (data.logistics_type == this.eLogisticsType.Direct && data.depot_in_type == 1);
        this.formData = {
            logistics_type: data.logistics_type,
            depot_in_model: data.depot_in_model,
            from_system: data.from_system,
            order_type: data.order_type,
            business_id: data.business_id,
            supplier_to_business_id: data.supplier_to_business_id,
            shop_id: data.shop_id,
            organ_id: data.organ_id,
            out_depot_id: data.out_depot_id,
            depot_id: data.depot_id,
            depot_name: data.depot_name,
            expect_arrivedate: data.expect_arrivedate,
            reciever_phone: data.reciever_phone,
            deliverer_id: data.deliverer_id,
            deliverer_phone: data.deliverer_phone || '',
            delivery_plate_number: data.delivery_plate_number || '',
            delivery_time: data.delivery_time,
            order_icomment: data.order_icomment,
            delivery_order_code: data.delivery_order_code,
            order_id: data.order_id,
            order_type_name: data.order_type_name,
            purchase_order_order: data.purchase_order_order,
            organ_name: data.organ_name,
            shop_name: data.shop_name,
            out_depot_name: data.out_depot_name,
            sorting_order: data.sorting_order,
            customer: data.customer,
            delivery_order_status: data.delivery_order_status,
            poo_last_ctime: data.poo_last_ctime,
            is_modify_oamount: data.is_modify_oamount,
            is_modify_uprice: data.is_modify_uprice,
            is_show_uprice: data.is_show_uprice,
            is_stock_up: data.detail[0].is_stock_up,
            is_split_order: data.is_split_order,
            can_gift_goods: data.can_gift_goods,
            reciever_address: data.reciever_address,
            vir_through_is_show_uprice: data.vir_through_is_show_uprice,
            logistics_number: data.logistics_number,
            appointment_delivery_time: data.appointment_delivery_time,
            is_open_appointment_delivery_time: data.is_open_appointment_delivery_time,
            is_open_appointment_delivery_time_force: data.is_open_appointment_delivery_time_force
        };
        this.goodList = this.generateGoodsTableData(data.detail || []);
        var shopList = data.shop_detail || [];
        shopList.forEach(function (item) {
            item.items = _this.generateGoodsTableData(item.items || []);
        });
        this.shopList = shopList;
        this.baseGoodList = _.cloneDeep(this.goodList);
        this.baseShopList = _.cloneDeep(this.shopList);
        this.initOutDepotOptions();
        this.isReady = true;
    };
    default_1.prototype.getEditOrderInfo = function () {
        var _this = this;
        if (this.shipData) {
            this.initEditOrderData(this.shipData);
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.deliverService
            .getEditOrderInfo({
            order_id: this.order_id,
        })
            .then(function (res) {
            var data = res.data.data;
            _this.initEditOrderData(data);
            loadingInstance.close();
        })
            .catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    default_1.prototype.resetOutDepotOptions = function () {
        var _this = this;
        var CALL_BACK = function () {
            var defaultDepotId = '';
            var defaultDepotName = '';
            _this.depotList.some(function (item) {
                if (item.is_organ_default == 1) {
                    defaultDepotId = item.depot_id;
                    defaultDepotName = item.depot_name;
                }
            });
            _this.goodList.forEach(function (row) {
                row.out_depot_id = defaultDepotId;
                row.out_depot_name = defaultDepotName;
                if (row.items && row.items.length) {
                    row.items.map(function (item) {
                        item.out_depot_id = defaultDepotId;
                        item.out_depot_name = defaultDepotName;
                    });
                }
                _this.getOutDepotOptionsOneOrZero(row);
            });
        };
        this.getDepotList(CALL_BACK);
    };
    default_1.prototype.initOutDepotOptions = function () {
        var _this = this;
        this.goodList.forEach(function (row) {
            row.out_depot_id = row.out_depot_id == 0 ? '' : row.out_depot_id;
            console.log('initOutDepotOptions===>', row.out_depot_id);
            _this.getOutDepotOptionsOneOrZero(row);
        });
    };
    default_1.prototype.getOutDepotOptionsOneOrZero = function (row, trigger) {
        var data = [];
        if (row.out_depot_id) {
            data.push({
                depot_id: row.out_depot_id,
                depot_name: row.out_depot_name,
            });
        }
        var index = this.goodList.indexOf(row);
        GLOBAL_VUE.$set(this.goodList[index], 'outDepotOptions', data);
    };
    default_1.prototype.save = function (res) {
        var status = res.status, callback = res.callback;
        console.log('------save goodsData', _.cloneDeep(this.goodList));
        if (this.handleStatus === EHandleStatus.Edit) {
            this.updateDeliveryOrder(status, callback);
        }
        else {
            this.addDeliveryOrder();
        }
    };
    default_1.prototype.updateDeliveryOrder = function (status, callback) {
        var _this = this;
        if (this.formData.from_system == 5 && status == 1) {
            var goodList = Array.isArray(this.goodList) ? this.goodList : [];
            var purchaseOrderList = Array.isArray(this.formData.purchase_order_order) ? this.formData.purchase_order_order : [];
            var orderInfo = '';
            var isMoneyNegative_1 = false;
            if (this.shipData) {
                var orders = purchaseOrderList.map(function (v) { return v.order_code; }).join('，');
                orderInfo = "\u8BA2\u8D27\u5355\u53F7\uFF1A" + orders;
            }
            else {
                orderInfo = "\u9001\u8D27\u5355\u53F7\uFF1A" + this.formData.delivery_order_code;
            }
            goodList.map(function (v) {
                if (Number(v.order_detail_money) < 0) {
                    isMoneyNegative_1 = true;
                }
                return v;
            });
            if (isMoneyNegative_1) {
                this.$confirm(orderInfo + "\u4E2D\u5B58\u5728\u5B9E\u4ED8\u91D1\u989D\u4E3A\u8D1F\u6570\u7684\u8D27\u54C1\uFF0C\u53D1\u8D27\u540E\u4E0D\u53EF\u4FEE\u6539\uFF0C\u786E\u8BA4\u53D1\u8D27\u4E48\uFF1F").then(function () {
                    _this.handleDeliveryOrder(status, callback);
                }, function (err) { });
            }
            else {
                this.handleDeliveryOrder(status, callback);
            }
        }
        else {
            this.handleDeliveryOrder(status, callback);
        }
    };
    default_1.prototype.handleDeliveryOrder = function (status, callback) {
        var _this = this;
        var data = _.cloneDeep(this.activeTab === 'goods' ? this.goodList : this.shopList.map(function (item) { return item.items; }).flat());
        console.log('------handleDeliveryOrder', data);
        try {
            data.forEach(function (item) {
                item['order_detail_goods_money_real'] = new Number(_.multiply(item.order_detail_uprice, item.order_detail_oamount)).toFixedNoZero(4);
                item['order_detail_money_real'] = numSub(_.multiply(item.order_detail_oamount, item.order_detail_uprice), item.order_detail_reduction_money || 0).toFixedNoZero(4);
                if (!_this.orderHasMerge) {
                    item.goods_icomment = item.order_detail_icomment;
                }
                if (item.items && item.items.length === 1) {
                    item.items[0].order_detail_oamount = item.order_detail_oamount;
                    item.items[0].order_gift_oamount = item.order_gift_oamount;
                    item.items[0].order_detail_icomment = item.order_detail_icomment;
                    item.items[0].out_depot_id = item.out_depot_id;
                }
            });
        }
        catch (err) {
            this.$message.warning(err.message);
            return;
        }
        console.log('------handleDeliveryOrder', data, this.activeTab, this.goodList, this.shopList);
        var params = {
            delivery_order_id: this.order_id,
            organ_id: this.formData.organ_id,
            out_depot_id: this.formData.out_depot_id,
            expect_arrivedate: this.formData.expect_arrivedate ? moment(this.formData.expect_arrivedate).format('YYYY-MM-DD') : this.formData.expect_arrivedate,
            reciever_phone: this.formData.reciever_phone,
            deliverer_id: this.formData.deliverer_id,
            deliverer_phone: this.formData.deliverer_phone,
            delivery_plate_number: this.formData.delivery_plate_number,
            delivery_time: this.formData.delivery_time
                ? moment(this.formData.delivery_time).format('YYYY-MM-DD HH:mm:ss')
                : '',
            order_icomment: this.formData.order_icomment,
            delivery_order_status: status,
            reciever_address: this.formData.reciever_address,
            logistics_number: this.formData.logistics_number,
            data: JSON.stringify(data),
        };
        var bindUpdateOrderAjax = function (params) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.deliverService.updateDeliveryOrder(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 0) {
                    _this.$message.success('操作成功');
                    console.log(11211, callback);
                    if (callback) {
                        callback();
                    }
                    else {
                        setTimeout(function () {
                            GLOBAL_VUE.$emit('closeTab', _this);
                            _this.opener.search();
                        }, 500);
                    }
                    return;
                }
                if (res.data.code === 67) {
                    var text = res.data.msg.split('？');
                    var confirmText = [text[0] + '？', text[1]];
                    var newDatas = [];
                    var h = _this.$createElement;
                    for (var i in confirmText) {
                        newDatas.push(h('p', null, confirmText[i]));
                    }
                    _this.$confirm('提示', {
                        title: '提示',
                        message: h('div', null, newDatas),
                        confirmButtonText: "是",
                        cancelButtonText: "否",
                        type: "success",
                        showClose: false,
                    }).then(function (res) {
                        if (res) {
                            bindUpdateOrderAjax(__assign({}, params, { split_confirm: 1 }));
                            return;
                        }
                    }).catch(function (action) {
                        if (action === "cancel") {
                            bindUpdateOrderAjax(__assign({}, params, { split_confirm: 0 }));
                        }
                    });
                    return;
                }
                if (res.data.code === 54) {
                    var instance_1 = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    instance_1.$on('artMsglist:ok', function (data) {
                        var confirm = res.data.data[0].confirm;
                        bindUpdateOrderAjax(__assign({}, params, { confirm: confirm }));
                    });
                    return;
                }
                if (res.data.code === 77) {
                    var instance_2 = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350
                    }).instance;
                    return;
                }
                if (res.data.code === 17) {
                    var instance_3 = _this.$dialog(ArtMsglist, {
                        data: {
                            msgData: res.data.data,
                            txtColor: "#FF2605"
                        },
                    }, {
                        title: '提示',
                        width: 450,
                        height: 350,
                    }).instance;
                    instance_3.$on('artMsglist:ok', function (data) {
                        bindUpdateOrderAjax(__assign({}, params, { stock_confirm: 1 }));
                    });
                    return;
                }
                var instance = _this.$dialog(ArticleList, {
                    data: {
                        resData: res.data,
                        modelType: 'deliver'
                    },
                }, {
                    title: '提示',
                    width: 450,
                    height: 350,
                    closeBtn: false,
                }).instance;
                instance.$on('addClient:ok', function (data) {
                    if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                        _this.addTab({
                            component: Client,
                            title: '合作客户',
                            name: '合作客户'
                        });
                    }
                    if (res.data.code == EPurOrderErrorCode.GOODS_STOCK_IS_SHORT) {
                        _this.addTab({
                            component: Purchase,
                            title: '采购入库',
                            name: '采购入库'
                        });
                    }
                });
            })
                .catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance.close();
            });
        };
        bindUpdateOrderAjax(params);
    };
    default_1.prototype.addDeliveryOrder = function () {
        var _this = this;
        try {
            this.validateSaveDeliver(this.formData);
            if (!this.goodList.length) {
                throw new Error('货品信息不能为空');
            }
            var amount = 0;
            for (var i = 0; i < this.goodList.length; i++) {
                if (parseFloat(this.goodList[i].order_detail_uprice) == 0) {
                    throw new Error('单价不能为 0');
                    break;
                }
            }
        }
        catch (err) {
            this.$message.warning(err.message);
            return;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.goodList.forEach(function (item, index) {
            item['order_detail_goods_money_real'] = new Number(_.multiply(item.order_detail_uprice, item.order_detail_oamount)).toFixedNoZero(4);
            item['order_detail_money_real'] = numSub(_.multiply(item.order_detail_oamount, item.order_detail_uprice), item.order_detail_reduction_money || 0).toFixedNoZero(4);
            item.order_detail_goods_money = item.order_detail_goods_money_real;
        });
        var params = {
            order_type: this.formData.order_type,
            business_id: this.formData.business_id,
            supplier_to_business_id: this.formData.supplier_to_business_id,
            shop_id: this.formData.shop_id,
            organ_id: this.formData.organ_id,
            out_depot_id: this.formData.out_depot_id,
            depot_id: this.formData.depot_id,
            depot_name: this.formData.depot_name,
            expect_arrivedate: this.formData.expect_arrivedate ? moment(this.formData.expect_arrivedate).format('YYYY-MM-DD') : this.formData.expect_arrivedate,
            reciever_phone: this.formData.reciever_phone,
            deliverer_id: this.formData.deliverer_id,
            deliverer_phone: this.formData.deliverer_phone,
            delivery_plate_number: this.formData.delivery_plate_number,
            delivery_time: this.formData.delivery_time
                ? moment(this.formData.delivery_time).format('YYYY-MM-DD HH:mm:ss')
                : '',
            order_icomment: this.formData.order_icomment,
            delivery_order_status: 0,
            reciever_address: this.formData.reciever_address,
            logistics_number: this.formData.logistics_number,
            data: JSON.stringify(this.goodList),
        };
        return this.deliverService
            .addDeliveryOrder(params)
            .then(function (res) {
            _this.$message.success('保存成功');
            setTimeout(function () {
                GLOBAL_VUE.$emit('closeTab', _this);
                _this.opener.search();
            }, 500);
            loadingInstance.close();
        })
            .catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    default_1.prototype.addGoods = function () {
        var _this = this;
        try {
            this.validateAddGood(this.formData);
        }
        catch (err) {
            this.$message.warning(err.message);
            return;
        }
        var goodIds = [];
        this.goodList.forEach(function (item) {
            goodIds.push(item.goods_format_id);
        });
        var instance = this.$dialog(DistriDialog, {
            data: {
                supplier_upper_id: 1,
                formData: this.formData,
                openedCodeData: this.openedCodeData,
                selectedGoodIds: goodIds,
            },
        }, {
            title: '添加货品',
            width: 750,
            height: 650,
        }).instance;
        instance.$on('save:ok', function (selectGood) { return __awaiter(_this, void 0, void 0, function () {
            var loadingInstance_1, goods_ids;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectGood.length) return [3, 3];
                        if (!(this.handleStatus === EHandleStatus.Edit)) return [3, 2];
                        return [4, this.deliverService.getDetailAddGoods({
                                order_id: this.order_id,
                                data: JSON.stringify(selectGood),
                            }).then(function (res) {
                                selectGood = res.data.data;
                            }).catch(function (err) {
                                _this.$message.error(err.msg || err.message);
                                loadingInstance_1.close();
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        loadingInstance_1 = Loading.service({ fullscreen: true });
                        goods_ids = selectGood.map(function (item) { return item.supplier_goods_id; });
                        this.basicArcheivesService
                            .getDepotId({
                            organ_id: this.formData.organ_id,
                            shop_id: this.formData.shop_id,
                            goods_ids: goods_ids.join(','),
                        })
                            .then(function (res) {
                            loadingInstance_1.close();
                            var data = res.data.data;
                            var ruleOutDepotIds = data && data.goods_depot_map;
                            selectGood.forEach(function (item) {
                                item.supplier_goods_format = item.supplier_goods_format || item.goods_format_name;
                                var ruleOutDepotId = ruleOutDepotIds[item.supplier_goods_id];
                                if (ruleOutDepotId && ruleOutDepotId.depot_id) {
                                    item.out_depot_id = ruleOutDepotId.depot_id;
                                    item.out_depot_name = ruleOutDepotId.depot_name;
                                }
                                _this.goodList.push(item);
                                _this.getOutDepotOptionsOneOrZero(item);
                            });
                        })
                            .catch(function (err) {
                            _this.$message.error(err.msg || err.message);
                            loadingInstance_1.close();
                        });
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        }); });
    };
    default_1.prototype.importGood = function (selectGood) {
        return __awaiter(this, void 0, void 0, function () {
            var loadingInstance_2, goods_ids;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.cacheOcrImportGood(selectGood);
                        this.uploadShow = false;
                        if (!selectGood.length) return [3, 3];
                        if (!(this.handleStatus === EHandleStatus.Edit)) return [3, 2];
                        return [4, this.deliverService.getDetailAddGoods({
                                order_id: this.order_id,
                                data: JSON.stringify(selectGood),
                            }).then(function (res) {
                                selectGood = res.data.data;
                            }).catch(function (err) {
                                _this.$message.error(err.msg || err.message);
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        loadingInstance_2 = Loading.service({ fullscreen: true });
                        goods_ids = selectGood.map(function (item) { return item.supplier_goods_id; });
                        this.basicArcheivesService
                            .getDepotId({
                            organ_id: this.formData.organ_id,
                            shop_id: this.formData.shop_id,
                            goods_ids: goods_ids.join(','),
                        })
                            .then(function (res) {
                            loadingInstance_2.close();
                            var data = res.data.data;
                            var ruleOutDepotIds = data && data.goods_depot_map;
                            selectGood.forEach(function (item) {
                                item.supplier_goods_format = item.supplier_goods_format || item.goods_format_name;
                                item.order_detail_oamount = item.amount || 0;
                                var ruleOutDepotId = ruleOutDepotIds[item.supplier_goods_id];
                                if (ruleOutDepotId) {
                                    var target = _this.depotList.find(function (ele) { return ele.depot_id === ruleOutDepotId; });
                                    if (target) {
                                        item.out_depot_id = target.depot_id;
                                        item.out_depot_name = target.depot_name;
                                    }
                                    else {
                                        item.out_depot_id = '';
                                        item.out_depot_name = '';
                                    }
                                }
                                _this.goodList.push(item);
                                _this.getOutDepotOptionsOneOrZero(item);
                            });
                        })
                            .catch(function (err) {
                            _this.$message.error(err.msg || err.message);
                            loadingInstance_2.close();
                        });
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    default_1.prototype.cacheOcrImportGood = function (selectGood) {
        var _this = this;
        this.ocrImportGoodList = this.ocrImportGoodList && this.ocrImportGoodList.length ? this.ocrImportGoodList : [];
        if (selectGood && selectGood.length) {
            selectGood.forEach(function (item) {
                item.supplier_goods_format = item.supplier_goods_format || item.goods_format_name;
                _this.ocrImportGoodList.push(item);
            });
        }
    };
    default_1.prototype.updateOcrGood = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var goodList = [];
        if (this.ocrImportGoodList && this.ocrImportGoodList.length) {
            var loadingInstance_3 = Loading.service({ fullscreen: true });
            var goods_format_ids = this.selections && this.selections.length ? this.selections.map(function (item) { return item.goods_format_id; }).join(',') : '';
            var params = {
                shop_id: this.formData.shop_id,
                organ_id: this.formData.organ_id,
                business_id: this.formData.business_id,
                supplier_to_business_id: this.formData.supplier_to_business_id,
                goods_format_ids: goods_format_ids,
                is_no_price_goods: 1,
            };
            this.deliverService.getGoodsList(Object.assign({}, params, pager)).then(function (res) {
                if (res.data.success) {
                    var data_1 = res.data.data || [];
                    data_1.length && _this.ocrImportGoodList.forEach(function (item) {
                        var target = data_1.find(function (good) { return good.goods_id === item.goods_id; });
                        if (target) {
                            item.order_detail_uprice = target.order_detail_uprice || 0;
                        }
                        goodList.push(item);
                    });
                    _this.goodList = goodList;
                }
                loadingInstance_3.close();
            }, function (err) {
                _this.$message.error(err.message);
                loadingInstance_3.close();
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance_3.close();
            });
        }
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        if (this.selections.length == this.goodList.length) {
            this.$message.warning('请至少保留一个货品');
            return;
        }
        this.$confirm('请确认是否删除该货品', '提示').then(function (res) {
            if (_this.handleStatus === EHandleStatus.Edit) {
                var goods_format_ids = _this.selections.map(function (item) { return item.goods_format_id; });
                _this.deliverService.detailDelGoods({
                    order_id: _this.order_id,
                    goods_format_ids: goods_format_ids.join(','),
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
            _this.selections.forEach(function (item) {
                var index = _this.goodList.indexOf(item);
                _this.goodList.splice(index, 1);
            });
        }, function (err) { });
    };
    default_1.prototype.validateSaveDeliver = function (data) {
        if (!data.order_type && data.order_type !== 0) {
            throw new Error('请选择单据类型');
            return;
        }
        if (!data.organ_id && data.organ_id !== 0) {
            throw new Error('请选择出库机构');
            return;
        }
        if (!data.out_depot_id && data.out_depot_id !== 0) {
            throw new Error('该出库机构没有可用仓库，请检查仓库档案中该是否已创建仓库且已初始化库存并启用。');
            return;
        }
        if (!data.business_id && data.business_id !== 0) {
            throw new Error('请选择收货机构');
            return;
        }
        if (!data.expect_arrivedate) {
            throw new Error('请选择预计收货时间');
            return;
        }
    };
    default_1.prototype.validateAddGood = function (data) {
        if (!data.order_type && data.order_type !== 0) {
            throw new Error('请选择单据类型');
            return;
        }
        if (!data.shop_id) {
            throw new Error('请选择收货门店');
            return;
        }
        if (!data.out_depot_id && data.out_depot_id !== 0) {
            throw new Error('该出库机构没有可用仓库，请检查仓库档案中该是否已创建仓库且已初始化库存并启用。');
            return;
        }
        if (!data.business_id && data.business_id !== 0) {
            throw new Error('请选择收货机构');
            return;
        }
    };
    default_1.prototype.seeBindLicenses = function (row) {
        GLOBAL_VUE.$emit('addTab', {
            component: SeeBindLicenses,
            opener: this,
            title: '查看证照',
            showExist: true,
            name: 'goods-see-bind-license' +
                row.supplier_goods_id +
                'goods_format_id' +
                row.goods_format_id +
                'order_id' +
                this.order_id +
                'order_detail_id' +
                row.order_detail_id,
            cprops: {
                from_page: 'deliver',
                order_id: this.order_id,
                order_detail_id: row.order_detail_id,
                goods_id: row.supplier_goods_id,
                goods_name: row.supplier_goods_name,
                goods_code: row.supplier_goods_code,
                goods_format_id: row.goods_format_id,
                goods_format_name: row.supplier_goods_format,
            },
        });
    };
    default_1.prototype.addTab = function (options) {
        options.opener = this;
        options.showExist = true,
            GLOBAL_VUE.$emit('addTab', options);
    };
    default_1.prototype.getDownloadParams = function () {
        var params = this.data.map(function (item) {
            return {
                goods_code: item.goods_code || '',
                goods_name: item.goods_name || '',
                goods_format_name: item.goods_format_name || '',
                purchase_unit_name: item.purchase_unit_name || '',
                order_detail_amount: item.order_detail_amount || '',
                order_detail_uprice: item.order_detail_uprice,
                production_date: item.production_date,
                order_detail_icomment: item.order_detail_icomment || '',
            };
        });
        return JSON.stringify(params);
    };
    default_1.prototype.toImport = function () {
        this.dialogTableVisible = true;
        this.getDepotList();
        this.setUploadType("beford");
    };
    default_1.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (!(fileType && (fileType == "xlsx" || fileType == "xls"))) {
            this.$message.error("文件只能是xlsx或xls");
            return false;
        }
        ;
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    default_1.prototype.uploadSuccess = function (response, file, fileList) {
        var _this = this;
        this.loadingInstance.close();
        if (response.success) {
            var dataVal = response.data;
            this.responseSuccess = dataVal.import_id ? true : false;
            this.importFailnum = dataVal.error_num;
            var url = "/basicapi/export_error?import_id=" + dataVal.import_id + "&type=" + dataVal.type;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            var goodsList_1 = dataVal.goods_list || [];
            console.log(444, goodsList_1, this.goodList);
            if (goodsList_1.length) {
                console.log(555, this.goodList);
                this.goodList = this.goodList.map(function (item) {
                    return __assign({}, item, { order_detail_tax_rate: Number(item.order_detail_tax_rate), order_detail_uprice: Number(item.order_detail_uprice) });
                });
                var currentDay = moment().format('YYYY-MM-DD');
                this.goodList = this.goodList.map(function (good) {
                    var goodsItem = goodsList_1.find(function (item) {
                        return ((item.goods_format_id && item.goods_format_id == good.goods_format_id) || (item.goods_id && item.goods_id == good.goods_id)) && (!item.depot_name || item.depot_name == good.depot_name);
                    });
                    if (!goodsItem) {
                        return good;
                    }
                    if (good.items && good.items.length) {
                        good.order_detail_oamount = 0;
                        good.items = good.items.map(function (item) {
                            var goodsItem2 = goodsList_1.find(function (goods) {
                                if (goods.goods_format_id && good.goods_format_id) {
                                    return goods.goods_format_id == good.goods_format_id
                                        && goods.goods_id == good.goods_id
                                        && goods.shop_id == item.shop_id
                                        && goods.depot_name == item.depot_name;
                                }
                                else {
                                    return goods.goods_id == good.goods_id
                                        && goods.shop_id == item.shop_id
                                        && goods.depot_name == item.depot_name;
                                }
                            });
                            if (!goodsItem2) {
                                console.log("goodsItem2", goodsItem, item);
                                return item;
                            }
                            goodsList_1 = goodsList_1.map(function (item) {
                                if (item.order_detail_id == goodsItem2.order_detail_id) {
                                    item.order_detail_oamount = Number(goodsItem2.order_detail_oamount);
                                }
                                return item;
                            })
                                .filter(function (item) { return item.order_detail_oamount !== 0; });
                            if (_this.formData.is_modify_oamount) {
                                item.order_detail_oamount = Number(goodsItem2.order_detail_oamount);
                            }
                            item.order_gift_oamount = Number(goodsItem2.order_gift_oamount);
                            item.production_date = goodsItem2.production_date;
                            item.order_detail_icomment = goodsItem2.order_detail_icomment;
                            item.order_detail_money = Number(goodsItem2.order_detail_money);
                            good.order_detail_oamount += Number(item.order_detail_oamount);
                            item.out_depot_id = goodsItem2.out_depot_id;
                            return item;
                        });
                    }
                    console.log(123, goodsItem);
                    if (_this.formData.is_modify_oamount && goodsItem.order_detail_oamount != null) {
                        if (good.items && good.items.length) {
                            good.order_detail_oamount = good.items.reduce(function (total, item) {
                                console.log(2221, item.order_detail_oamount, good.items);
                                return total + Number(item.order_detail_oamount);
                            }, 0);
                        }
                        else {
                            good.order_detail_oamount = Number(goodsItem.order_detail_oamount);
                        }
                    }
                    if (_this.formData.is_modify_uprice && goodsItem.order_detail_uprice !== null) {
                        good.order_detail_uprice = Number(goodsItem.order_detail_uprice);
                    }
                    console.log(121312312, goodsItem.order_detail_uprice);
                    if (goodsItem.order_gift_oamount !== null) {
                        good.order_gift_oamount = Number(goodsItem.order_gift_oamount);
                    }
                    good.production_date = goodsItem.production_date;
                    good.order_detail_icomment = goodsItem.order_detail_icomment;
                    good.order_detail_money = good.order_detail_uprice * good.order_detail_oamount;
                    good.order_detail_goods_money = good.order_detail_money;
                    good.order_detail_tax_money = good.order_detail_goods_money * good.order_detail_tax_rate;
                    good.out_depot_id = goodsItem.out_depot_id;
                    good.upper_warehouse_uprice = goodsItem.upper_warehouse_uprice;
                    console.log(123, good.order_detail_tax_money);
                    GLOBAL_VUE.$set(good, 'outDepotOptions', _this.depotList);
                    return good;
                });
                console.log(333, this.goodList);
                this.selections = [];
                if (!this.importFailnum) {
                    this.dialogTableVisible = false;
                }
            }
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    default_1.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    default_1.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    default_1.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    default_1.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    __decorate([
        Watch('formData.order_type')
    ], default_1.prototype, "watchOrderType", null);
    __decorate([
        Watch('formData.shop_id')
    ], default_1.prototype, "watchshop_id", null);
    __decorate([
        Watch('formData.organ_id')
    ], default_1.prototype, "watchorgan_id", null);
    __decorate([
        Watch('formData.out_depot_id')
    ], default_1.prototype, "watchout_depot_id", null);
    default_1 = __decorate([
        auth(nameDict['送货单'], true),
        Component({
            components: {
                TableFieldConfig: TableFieldConfig,
                'add-header': Header,
                'good-table': GoodTable,
                'mul-order-detail-oamount': MulOrderDetailOamount,
                'select-stock-batch': SelectStockBatch,
                'ocr-upload': OCRUpload
            },
            computed: __assign({}, mapGetters({
                user: 'user',
                isErp: 'isErp',
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus',
                canSelectBatch: 'canSelectBatch',
            }), { isHideGiftAmount: function () {
                    var billData = this.formData || {};
                    return (billData.logistics_type === 2 && billData.depot_in_model === 1) ||
                        [4, 5].includes(billData.logistics_type) || billData.from_system === EOrderFromSystem['商城'];
                },
                isShowPrice: function () {
                    var isVirtualStraight = ![4, 5].includes(this.formData.logistics_type);
                    return !(isVirtualStraight && this.handleStatus === EHandleStatus.Edit && this.formData.is_show_uprice !== 1);
                },
                ocrParams: function () {
                    var goods_format_ids = this.selections && this.selections.length ? this.selections.map(function (item) { return item.goods_format_id; }).join(',') : '';
                    var supplier_to_business_id = this.formData && this.formData.supplier_to_business_id ? this.formData.supplier_to_business_id : '';
                    return { goods_format_ids: goods_format_ids, supplier_to_business_id: supplier_to_business_id };
                } }),
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
